import Vue from "vue";
import App from "@/App";
import router from "@/router";
import store from "@/store";
import { isMobile } from "@/utils/common.js";
// 公共样式2
import "@/styles/index.scss";

// 加载pc端/移动端样式
async function importCss() {
  if (!isMobile()) {
    await import("@/styles/pc/index.scss");
    await import("@/styles/pc/icons.scss");
  } else {
    await import("@/styles/h5/common.scss");
    await import("@/styles/h5/icons.scss");
  }
}
importCss();

// 添加指令
import language from "@/directive/language";
Vue.use(language);
// 语言包
import i18n from "@/common/config/i18n";
Vue.config.productionTip = false;
Vue.prototype.$store = store;
router.beforeEach((to, from, next) => {
  store.dispatch('pageInfo/setLayoutOptions', to.meta.layoutOptions)
  next()
})
/* eslint-disable no-new */
const vue = new Vue({
  el: "#app",
  router,
  i18n,
  store,
  components: { App },
  template: "<App/>"
});
export default vue;



// WEBPACK FOOTER //
// ./src/main.js